import type { cryptoTokens, Theme } from '@pijma/hero-types'

import tokens from './tokens'

export const crypto: Theme<cryptoTokens> = {
  meta: {
    version: '0.0.0',
    name: 'crypto',
  },
  tokens,
}

export const light = crypto
export const dark = crypto
